export default __webpack_public_path__ + "static/media/volar-white.9f66d136.svg";